import React from 'react';

interface IProps {
  image: string;
  type: string;
}

const Viewer: React.FC<IProps> = ({ image, type }) => {
  return (
    <>
      {type == 'image/jpg' || type == 'image/jpeg' ? (
        <img src={image} alt='group image' style={{ width: '500px' }} />
      ) : (
        <video src={image} style={{ width: '400px' }} controls />
      )}
    </>
  );
};

export default Viewer;
